/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions')

'use strict';

class DateSchemaDirective {

    public restrict;
    public require;
    public scope;
    public template;
    public replace;
    public org;

    constructor(private Orgs:any) {
        this.restrict = 'E';
        this.scope = {
            model: '='
        };
        this.replace = true;
        this.template = `
            <div class="btn-group">
                <input type="text"
                  uib-datepicker-popup="dd.MM.yyyy"
                  ng-model="localModel"
                  data-ng-change="setDate()"
                  ng-click="popup.opened1=true"
                  data-is-open="popup.opened1"
                  data-datepicker-popup-template-url="/static/templates/datepicker/popup.html"
                  data-datepicker-template-url="/static/templates/datepicker/datepicker.html"
                  placeholder="dd.MM.yyyy"
                  datepicker-options="options"
                  class="form-control text-center"/>
              </div>
        `;
    }

    public link = (scope: any, elem, attrs) => {

        let dereg = scope.$watch('model', (newVal) => {
          let val = moment(newVal, 'YYYY-MM-DD');

            if (newVal && moment.isDate(val.toDate())) {

                if(attrs.kind == "from"){
                  scope.$root.$broadcast('fromLeaveDateChanged', {'minDate': val.toDate()})
                }
                if(attrs.kind == "to"){
                  scope.$root.$broadcast('toLeaveDateChanged', {'maxDate': val.toDate()})
                }
                scope.localModel = val.toDate();
            }

        });

        this.Orgs.getOrgFromCache((response) => {
            this.org = response
            if(attrs.weekendDisabled === "true"){
            var work_days = functions.get_work_days(this.org)
                scope.dateDisabled = (date, mode) => {
                    return (date.mode === 'day' && !_.includes(work_days,date.date.getDay()));
                }
            }
        })


        scope.options = {
          dateDisabled: scope.dateDisabled,
          showWeeks: false
        }
        if(attrs.kind == "from"){
          scope.$root.$on("toLeaveDateChanged", (event, args) => {
            scope.options.maxDate = args.maxDate;
          })
        }
        if(attrs.kind == "to"){
          scope.$root.$on("fromLeaveDateChanged", (event, args) => {
            scope.options.minDate = args.minDate;
          })
        }

        scope.setDate = () => {
            scope.model = (scope.localModel) ? moment(scope.localModel).format('YYYY-MM-DD') : '';
        };

        scope.$on('$destroy', () => {
            dereg();
        })
    };

    public static DirectiveFn(Orgs: any): DateSchemaDirective {
        return new DateSchemaDirective(Orgs);
    }
}

DateSchemaDirective.DirectiveFn.$inject = ['Orgs'];

angular.module('beneple.global')
    .directive('datepickerSchema', DateSchemaDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/directives/datepicker_schema.directive.ts